/* src/app/components/doc-viewer-new/doc-viewer-bottom-panel/prompt-response/prompt-response.component.scss */
.main-response-container {
  padding: 10px;
  margin-top: 10px;
}
.main-response-container .main-response-block {
  border: 2px solid;
  border-radius: 2px;
  padding: 6px 16px 0px;
  font-size: 14px;
  display: flex;
  margin: 0;
}
.main-response-container .main-response-block .main-response-logo {
  width: 50px;
}
.main-response-container .main-response-block .main-response-text {
  flex-grow: 1;
  margin: 0 12px;
}
.hover-over-button {
  float: right;
  padding: 0px;
  border: unset;
  font-size: 12px;
  cursor: pointer;
  color: rgb(36, 62, 144);
  background: inherit;
}
:host-context(.dark-theme) .main-response-container .main-response-block {
  background: #202020;
  color: white;
  border: 2px solid #FFC107;
}
:host-context(.dark-theme) .hover-over-button {
  color: rgb(255, 193, 7) !important;
}
/*# sourceMappingURL=prompt-response.component.css.map */
